import classNames from 'classnames';
import Button from '../../../react/components/Button';
import Logo from '../../../react/features/AppHeader/components/Logo';
import { useAppContext } from '../../../react/hooks/useAppContext';
import styles from './style.m.less';

type Props = {
    setShowNavigation: (show: boolean) => void;
    showNavigation: boolean;
};

export default function TopBar({ setShowNavigation, showNavigation }: Props) {
    const { user } = useAppContext();

    return (
        <div className={styles.topBar}>
            <Button
                onClick={() => {
                    setShowNavigation(!showNavigation);
                }}
                kind="PLAIN"
                className={styles.menuButton}
                aria-expanded={showNavigation}
                aria-controls="mainNavigation"
            >
                <div className={classNames(styles.menuButtonIcon, { [styles.menuButtonIconOpen]: showNavigation })} />
                Menu
            </Button>
            <Logo user={user} iconOnly />
        </div>
    );
}
